export const PROMO_UTILS_I18N_NAMESPACE = '@mc/promo-utils'

// Non-members promo https://app.growthbook.io/features/promotions
export const PROMO_FEATURE_FLAG = 'promotions'
export const DUMMY_PROMO_CODE = 'parents-2022-promo'

// Members only promo https://app.growthbook.io/features/promo_members_only
export const MEMBERS_ONLY_PROMO_FEATURE_FLAG = 'promo_members_only'
